import { render, staticRenderFns } from "./ActivitiesDataTable.vue?vue&type=template&id=cc711cb6&scoped=true"
import script from "./ActivitiesDataTable.vue?vue&type=script&lang=js"
export * from "./ActivitiesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc711cb6",
  null
  
)

export default component.exports